// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-H":"H_dpu-detail-H__nUO_f"};